import React from "react";
import "./Tooltip.css";
import { TooltipPortal } from "./TooltipPortal";

interface TooltipProps {
    text: string;
    position: { x: number; y: number };
}

const Tooltip: React.FC<TooltipProps> = ({ text, position }) => {
    return (
        <TooltipPortal>
            <div
                className="custom-tooltip"
                style={{
                    left: `${position.x}px`,
                    top: `${position.y}px`,
                    position: "fixed",
                }}
            >
                {text}
            </div>
        </TooltipPortal>
    );
};

export default Tooltip;
